import React, { useState, useEffect } from "react";
import { toast } from "../../../components/toastNotification";
import TextInput from "../../../components/TextInput";
import { useRecoilState, useRecoilValue } from "recoil";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";
import BusinessOperationForm from "./BusinessOperationForm";
import AddButton from "../../../components/AddButton";
import EditButton from "../../../components/EditButton";
import ConfirmBoxDelete from "../../../components/ConfirmBoxDelete";

import useGetBusinessOperation from "./hooks/useBusinessOperation";
import useDeleteBusinessOperation from "./hooks/useDeleteBusinessOperation";
import useUpdateBusinessOperation from "./hooks/useUpdateBusinessOperation";
import {
  addStateBusinessOperation,
  selectedRowsStateBusinessOperation,
  setFilterTextBusinessOperation,
} from "./atoms/atoms";
import TableFilters from "./TableFilters";
import { PERMISSIONS } from "../../PermissionsConstants";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { notificationFilterById } from "../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import SaveButton from "../../../components/SaveButton";
import CancelButton from "../../../components/CancelButton";
import { useQueryClient } from "react-query";
import MaterialOfficeConfigTable from "../../../components/tables/MaterialOfficeConfigTable";

const BusinessOperationTable = () => {
  //Hooks Call
  const { data, isFetching } = useGetBusinessOperation();
  const { mutateAsync: UpdateBusinessOperation } = useUpdateBusinessOperation();
  const BulkDeleteBusinessOperation = useDeleteBusinessOperation();
  //Atoms Call
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateBusinessOperation
  );
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateBusinessOperation
  );
  const [filterText, setFilterText] = useRecoilState(
    setFilterTextBusinessOperation
  );
  //Local States
  const [rowsCount, setRowsCount] = useState(0);
  const [editRowId, setEditRowId] = useState(null);
  const [actionEditState, setActionEditState] = useState(false);
  const [, setBusinessOperationIsExistState] = useState(false);
  const [businessOperationDataIsChange, setBusinessOperationDataIsChange] =
    useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasBusinessOperation, setHasBusinessOperation] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [displayNote] = useState(false);
  const [edit, setEdit] = useState(false);
  const [businessOperationFilteredData, setBusinessOperationFilteredData] =
    useState([]);
  const queryClient = useQueryClient();
  const [editRowData, setEditRowData] = useState();

  const addPermission = PERMISSIONS.permission_utilities_businessoperation_add;
  const editPermission =
    PERMISSIONS.permission_utilities_businessoperation_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_businessoperation_delete;

  const userPermissions = useRecoilValue(permissionsSelector);

  const [hideColumn, sethideColumn] = useState(false);
  const defaultValues = {
    businessOperationId: 0,
    businessOperationName: "",
  };
  const [businessOperationNewData, setBusinessOperationNewData] = useState([
    defaultValues,
  ]);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (recordIdFromRecent !== "") {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setBusinessOperationFilteredData(result);
          setBusOpsId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
    setSelectedRows([]);
  }, []);

  useEffect(() => {
    setBusinessOperationIsExistState(false);
    setBusinessOperationDataIsChange(false);
    setEditRowId([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleCheckBox = (checked) => {
    setBusinessOperationDataIsChange(true);
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? businessOperationNewData.map((x) => (x.isActive = true))
      : businessOperationNewData.map((x) => (x.isActive = false));
  };

  const handleEditFieldsChange = (SourceType, fieldName, row, inputvalue) => {
    setBusinessOperationIsExistState(false);
    setBusinessOperationDataIsChange(false);
    inputvalue = inputvalue.trim();
    if (SourceType === "businessOperation") {
      if (fieldName === "BusinessOperationName") {
        setBusinessOperationDataIsChange(true);
        businessOperationNewData.map(
          (x) => (x.businessOperationName = inputvalue)
        );
      }
      inputvalue === ""
        ? setHasBusinessOperation(false)
        : setHasBusinessOperation(true);
    }
  };

  const handleEditButton = (rowData) => {
    setEditRowId(rowData.businessOperationId);
    setBusinessOperationDataIsChange(false);
    setCheckStatus(rowData.isActive);
    setEdit(true);
    setEditRowData({ ...rowData });
    businessOperationNewData.map((x) => (x.isActive = rowData.isActive));
    businessOperationNewData.map(
      (x) => (x.businessOperationId = rowData.businessOperationId)
    );
    businessOperationNewData.map(
      (x) => (x.businessOperationName = rowData.businessOperationName)
    );
    businessOperationNewData.map((x) => (x.createdBy = rowData.createdBy));
    businessOperationNewData.map((x) => (x.createdOn = rowData.createdOn));
  };
  //Save changes
  const handleSave = (businessOperationNewData) => {
    setOpenModalEdit(false);
    if (actionEditState) {
      UpdateBusinessOperation(businessOperationNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModalEdit(false);
          } else if (
            businessOperationNewData[0].businessOperationName ===
              editRowData.businessOperationName &&
            businessOperationNewData[0].isActive === editRowData.isActive
          ) {
            toast.fire("Saving Failed", "No Changes have been made", "warning");
            setOpenModalEdit(false);
          } else {
            setBusinessOperationNewData([defaultValues]);
            setEditRowId([]);
            setSelectedRows([]);
            setOpenModalEdit(false);
            setActionEditState(false);
            setDisabledButton(false);
            sethideColumn(false);
            setEdit(false);
            setBusinessOperationDataIsChange(false);
            queryClient.invalidateQueries(["GetBusinessOperation"]);
            toast.fire(
              "Success",
              "Business Operation Updated Successfully",
              "success"
            );
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Update Business Operation", "error");
          queryClient.invalidateQueries(["GetBusinessOperation"]);
          setOpenModalEdit(false);
        },
      });
    }
  };
  // end of saving changes

  const handleBulkDelete = () => {
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
    const ids = selectedRows.map((row) => row.businessOperationId);
    BulkDeleteBusinessOperation(ids);
    setSelectedRows([]);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Business Operations" : "Business Operation"
    } ?`}</div>
  );

  const matColumns = [
    {
      title: "Business Operation Name",
      field: "businessOperationName",
      customSort: (a, b) =>
        a.businessOperationName && b.businessOperationName
          ? a.businessOperationName
              .trim()
              .localeCompare(b.businessOperationName.trim())
          : a.businessOperationName
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.businessOperationId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Business Operation"
              defaultValue={rowData.businessOperationName}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "businessOperation",
                  "BusinessOperationName",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.businessOperationName}</>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.businessOperationId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.createdBy}</>
        );
      },
    },
    {
      title: "Created Date",
      field: "createdOn",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.businessOperationId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData.createdOn
              ? new Date(rowData.createdOn).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified Date",
      field: "modifiedOn",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.businessOperationId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData.modifiedOn
              ? new Date(rowData.modifiedOn).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.businessOperationId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.modifiedBy}</>
        );
      },
    },

    {
      title: "Status",
      field: "isActive",
      align: "left",
      render: (rowData) => {
        return rowData.businessOperationId === editRowId ? (
          <div className="flex justify-start space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left text-xs mr-4">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.businessOperationId === editRowId ? (
          <div className="flex place-content-center  gap-1">
            <SaveButton
              className={`flex shadow-md text-xs font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${
              !hasBusinessOperation || !businessOperationDataIsChange
                ? "opacity-50"
                : "opactiy-100"
            }`}
              disabled={!hasBusinessOperation || !businessOperationDataIsChange}
              onClick={() => {
                setOpenModalEdit(true);
              }}
            />
            <CancelButton
              className="flex text-xs shadow-md font-semibold text-white ml-1 gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClick={() => {
                setActionEditState(false);
                setEditRowId([]);
                setBusinessOperationDataIsChange(false);
                setBusinessOperationIsExistState(false);
                setDisabledButton(false);
                sethideColumn(false);
                setEdit(false);
              }}
            />
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5 ">
            <EditButton
              disabled={disabledButton || selectedRows.length > 0}
              className={
                disabledButton || selectedRows.length > 0
                  ? "opacity-50 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
                  : "opacity-100 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
              }
              onClick={() => {
                setDisabledButton(true);
                setActionEditState(true);
                handleEditButton(rowData);
                sethideColumn(true);
              }}
            />
          </div>
        );
      },
    },
  ];

  //Filters
  const [busOpsId, setBusOpsId] = useState("");
  useEffect(() => {
    if (filterText) {
      setBusinessOperationFilteredData(
        data?.filter((x) =>
          x.businessOperationName
            ?.toLowerCase()
            .includes(filterText.trim()?.toLowerCase())
        )
      );
    } else if (busOpsId?.includes(".")) {
      let busOpsIds = busOpsId.split(".");
      const busOpsIdsArr = busOpsIds.map((id) => Number(id));
      const filteredData = data?.filter((x) =>
        busOpsIdsArr.includes(x.businessOperationId)
      );

      setBusinessOperationFilteredData(filteredData);
    } else {
      const filteredData = data?.filter(
        (x) => x.businessOperationId === Number(busOpsId)
      );
      setBusinessOperationFilteredData(filteredData);
    }
  }, [filterText, data]);

  return (
    <div className="animate-fade-in-down bg-white p-4">
      {actionAddState ? "" : ""}
      {!actionAddState && (
        <>
          <div className="flex flex-row justify-between ">
            <TableFilters
              filterText={setFilterText}
              moduleDetails="Business Operation Name"
              textInputName="businessOperationName"
              disabledButton={disabledButton || selectedRows.length > 0}
            ></TableFilters>

            <div>
              {userPermissions.includes(addPermission) ? (
                <AddButton
                  buttonText="New Business Operation"
                  className={
                    selectedRows.length > 0 || actionEditState
                      ? "opacity-50"
                      : "opacity-100"
                  }
                  onClick={() => setActionAddState(!actionAddState)}
                  disabled={disabledButton || selectedRows.length > 0}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div>
            {userPermissions.includes(deletePermission) ? (
              <div className="text-secondary italic text-xs3 my-2">
                <p className="font-bold italic inline-block mr-1">Note:</p>
                <span>Tick the box to deactivate some data.</span>
              </div>
            ) : (
              <div className="mb-4"></div>
            )}
          </div>

          <div>
            <MaterialOfficeConfigTable
              columns={matColumns}
              data={
                businessOperationFilteredData?.length > 0
                  ? businessOperationFilteredData
                  : data
                  ? filterText === ""
                    ? data
                    : filterText
                  : []
              }
              options={{
                toolbar: false,
                showTitle: false,
              }}
              selection={
                !actionEditState && userPermissions.includes(deletePermission)
              }
              setOpenModal={setOpenModalDelete}
              onSelectionChange={handleSelectedRowsChange}
              selectedRows={selectedRows}
              isDeactivate={true}
              isLoading={isFetching}
            />
          </div>

          <ConfirmBoxModal
            ModalTitle="Update Business Operation"
            qConfirmation="Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => {
              setOpenModalEdit(false);
            }}
            onClickFunction={() => {
              handleSave(businessOperationNewData);
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate Business Operation"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={
              isBulkSelected ? handleBulkDelete : handleBulkDelete
            }
          />
        </>
      )}
      {actionAddState && (
        <div className="">
          <BusinessOperationForm />
        </div>
      )}
    </div>
  );
};

export default BusinessOperationTable;
